export * from './tmp.component';